import { render, staticRenderFns } from "./DashboardCompany.vue?vue&type=template&id=d4487d8e&scoped=true&"
import script from "./DashboardCompany.vue?vue&type=script&lang=js&"
export * from "./DashboardCompany.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCompany.vue?vue&type=style&index=0&id=d4487d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4487d8e",
  null
  
)

export default component.exports